<template>
  <mock-up-main>
    <!-- صفحه خوش‌آمدگویی (Splash Screen) -->
    <v-fade-transition>
      <div 
        v-if="showSplash" 
        class="splash-screen d-flex flex-column justify-center align-center w-100 h-100 position-absolute"
        style="z-index: 100; background: #ffffff;"
      >
        <img 
          v-if="value && value.photo && value.photo.welcome" 
          :src="value.photo.welcome" 
          alt="Welcome" 
          class="max-w-100 max-h-100 object-fit-contain"
        />
        <atom-spinner v-else :animation-duration="1000" :size="60" color="#1976d2" />
      </div>
    </v-fade-transition>

    <div class="d-flex flex-column h-100 position-relative w-100" style="overflow: hidden; background: #f8f9fa;">
      
      <!-- اشکال پس‌زمینه (دو تکه با فاصله) -->
      <div class="bg-shape-top" :style="{ background: backgroundImage ? `url(${backgroundImage}) no-repeat center center / cover` : (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.backGround) ? value.baseInfo.sectionColor.backGround : '#1e4881' }"></div>
      <div class="bg-shape-bottom" :style="{ background: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.backGround) ? value.baseInfo.sectionColor.backGround : '#1e4881' }"></div>

      <!-- لوگوی برند در بالای صفحه -->
      <div class="brand-logo-container position-absolute d-flex flex-column align-center" style="top: 25px; left: 20px; z-index: 20;">
        <div class="logo-circle elevation-4 d-flex justify-center align-center" style="background: #fff; width: 60px; height: 60px; border-radius: 50%;">
          <img 
            v-if="value && value?.photo?.profile" 
            :src="value.photo.profile" 
            alt="Logo" 
            style="width: 80%; height: 80%; object-fit: contain;"
          />
        </div>
        <span class="text-caption font-weight-bold mt-1 " style="text-shadow: 0 1px 3px rgba(0,0,0,0.3);"         
        :style="{
          color: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.text) ? value.baseInfo.sectionColor.text : '#333333'
        }"
>
          {{ (value && value.organizationName) ? value.organizationName : '' }}
        </span>
      </div>

      <!-- دکمه شناور شبکه‌های اجتماعی -->
      <floating-btn
        v-if="value && value.socialMedia && Object.keys(value.socialMedia).length > 0"
        v-model="value.socialMedia"
        :color="(value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.icon) ? value.baseInfo.sectionColor.icon : 'pink darken-2'"
        class="position-absolute glass-float-btn"
        style="top: 25px; right: 15px; z-index: 20;"       
      />

      <!-- بدنه اصلی اسکرول شونده -->
      <v-card
        flat
        class="main-glass-wrapper overflow-y-auto hide-scrollbar px-3 pt-12" 
        style="height: calc(100%); position: relative; z-index: 1; background: transparent;"
        :style="{
          color: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.text) ? value.baseInfo.sectionColor.text : '#333333'
        }"
      > 
        <div v-if="backgroundImage" class="bg-overlay" ></div>
        
        <drag-list v-model="draggingKeys" class="mt-8">
          <template v-slot:default="{ item }">
            <div :key="item.name || item" class="drag-item-wrapper mt-6 w-100 position-relative" style="z-index: 2;">

             <template v-if="(item.name || item) === 'banner'">
                <div v-if="computedBanner" class="main-circle elevation-8 mb-4">
                  <b-intro-slider-view
                    v-model="computedBanner"
                    :is-slider="false"
                    type="banner"
                    class="banner-slider-wrapper"
                  />
                </div>
              </template>

              <template v-if="(item.name || item) === 'profile'">
                <div class="profile-glass-card d-flex flex-column align-center text-center py-5 px-3 elevation-4 rounded-xl position-relative mt-12 mb-4"
                     style="background: rgba(255,255,255,0.85); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <div class="avatar-wrapper elevation-8" v-if="value && value.photo && value.photo.profile">
                    <img 
                      :src="value.photo.profile" 
                      alt="Profile" 
                      style="width: 100%; height: 100%; object-fit: cover;"
                    />
                  </div>
                  <h2 class="font-weight-black mt-4 text-h5 mb-1 text-truncate w-100 px-2"
                      :style="{ color: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.text) ? value.baseInfo.sectionColor.text : '#2c3e50' }">
                    {{ (value && value.organizationName) ? value.organizationName : ((value && value.visitName) ? value.visitName : 'مخاطب جدید') }}
                  </h2>
                  <!-- <p v-if="value && value.subtitle" class="font-weight-medium text-subtitle-2 opacity-80 mb-0 px-2">
                    {{ value.subtitle }}
                  </p> -->
                </div>
              </template>
             <template v-if="(item.name || item) === 'about' && ((value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable') || value?.website?.trim()!=='')">
                <div 
                  class="about-glass-card mx-4 mb-5 pa-6 rounded-xl elevation-3 d-flex flex-column align-center"
                  :style="{ 
                    border: `1px solid ${value?.baseInfo?.sectionColor?.backGround || 'rgba(255,255,255,0.4)'}`,
                    background: 'rgba(255, 255, 255, 0.25)',
                    backdropFilter: 'blur(12px)'
                  }"
                >
                  <!-- عنوان درباره من همراه با آیکون -->
                  <div 
                    v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')" 
                    class="d-flex align-center mb-2 justify-center w-100"
                  >
                    <v-icon small class="ml-2" :color="value?.baseInfo?.sectionColor?.text || '#333'">mdi-information-outline</v-icon>
                    <h3 class="text-subtitle-1 font-weight-black mb-0" :style="{ color: value?.baseInfo?.sectionColor?.text || '#333' }">
                      درباره من
                    </h3>
                  </div>

                  <!-- خط جداکننده (دیوایدر) شیک و کپسولی -->
                  <div 
                    v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')"
                    class="divider-line mb-4 rounded-pill" 
                    :style="{ 
                      height: '4px', 
                      width: '40px',
                      background: value?.baseInfo?.sectionColor?.backGround || '#1976d2',
                      opacity: 0.1
                    }"
                  ></div>

                  <!-- متن درباره من -->
                  <p 
                    v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')"
                    class="text-center mb-0 text-body-2 px-1" 
                    style="line-height: 2; font-weight: 500;" 
                    :style="{ color: value?.baseInfo?.sectionColor?.text || '#444' }"
                  >
                    {{ value.aboutUs }}
                  </p>

                  <!-- دکمه لینک وب‌سایت -->
                  <a 
                    v-if="value?.website" 
                    :href="value.website.startsWith('http') ? value.website : 'https://' + value.website" 
                    target="_blank" 
                    class="text-decoration-none mt-5 d-flex align-center justify-center font-weight-bold px-5 py-3 rounded-pill elevation-2 transition-swing w-100"
                    :style="{ 
                      color: value?.baseInfo?.sectionColor?.text || '#1976d2',
                      background: 'rgba(255, 255, 255, 0.25)',
                      border: `1px solid ${value?.baseInfo?.sectionColor?.text || '#1976d2'}30`,
                      maxWidth: '260px'
                    }"
                  >
                    <v-icon small class="ml-2" :color="value?.baseInfo?.sectionColor?.text || '#1976d2'">mdi-web</v-icon>
                    <span 
                      class="d-inline-block text-truncate" 
                      style="max-width: 170px; direction: ltr; text-align: left; letter-spacing: 0.5px; padding-top: 2px;"
                    >
                      {{ value.website.replace(/^https?:\/\//, '') }}
                    </span>
                  </a>
                </div>
              </template>


              <template v-if="(item.name || item) === 'socialMedia'">
                <div class="social-glass-container rounded-xl elevation-2 py-4 px-1 mt-4" 
                    style="background: rgba(255,255,255,0.85); backdrop-filter: blur(10px); display: block;">
                  <view-social v-model="value" :showHeader="true" style="width: 100%;"/>
                </div>
              </template>

            </div>
          </template>
        </drag-list>
        
        <div style="height: 180px; width: 100%; display: block; clear: both;"></div>
      </v-card>

      <!-- فوتر -->
        <div 
          class="fixed-footer w-100 position-absolute d-flex flex-column align-center pb-2 pt-3 px-4 elevation-10" 
          style="bottom: 0; z-index: 10; background: rgba(255,255,255,0.1); backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(10px); border-top-left-radius: 20px; border-top-right-radius: 20px;"
        >  
        <div class="d-flex flex-row w-100">
        <!-- <v-btn
          @click="getVcf"
          :loading="loadingVcf"
          rounded
          class="vcf-btn font-weight-bold text-subtitle-1 mb-2 elevation-4 white--text"
          height="48"
          :style="{
            width: (value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())) ? '85% !important' : '100% !important',
            background: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.backGround) ? `${value.baseInfo.sectionColor.backGround} !important` : '#1976d2',
            color: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.text) ? `${value.baseInfo.sectionColor.text} !important` : '#ffffff !important'
          }"
        >
          <v-icon right class="ml-2">mdi-account-plus</v-icon>
          ذخیره در مخاطبین
        </v-btn>   -->
          <v-tooltip 
            v-if="value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())"
              :value="
                value.advanceSettings &&
                value.advanceSettings.viewConfigs.showCClubOnload
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="vcf-btn font-weight-bold text-subtitle-1 mb-2 elevation-4 white--text mx-2"
                  dark
                  fab
                  small
                  width="48"
                  height="48"
                  v-bind="attrs"
                  v-on="on"
                  @click="show"
                  :style="{
                      background: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.backGround) ? `${value.baseInfo.sectionColor.backGround} !important` : '#1976d2',
                      color: (value && value.baseInfo && value.baseInfo.sectionColor && value.baseInfo.sectionColor.text) ? `${value.baseInfo.sectionColor.text} !important` : '#ffffff !important'
                      
                    }"

                >
                  <v-icon>mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>
              <span>{{
                value?.advanceSettings &&
                value?.advanceSettings?.viewConfigs?.showCClubOnload
                  ? "نمایش خودکار"
                  : "باشگاه مشتریان"
              }}</span>
          </v-tooltip>
          </div>      
        <div class="d-flex align-center justify-center opacity-70 mt-1" @click="openLink">
                   <img src="media/cr_logo.webp" alt="Terminal Ads Logo" height="18" style="filter: grayscale(1%);" />
          <span class="text-caption font-weight-medium mr-2" style="color: #666;">قدرت گرفته از کیوآر لند</span>
        </div>
      </div>
          
    </div>
  </mock-up-main>
</template>

<script>
import DragList from "@/view/pages/qrland/dragList"; 
import BIntroSliderView from "../../../../pages/businessPage/components/view/bIntroSliderView";
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import FloatingBtn from "./floatingBtn.vue";
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import { Bus } from "@/main";
import VideoCardView from "@/view/pages/otherQrTypes/videoGallery/components/videoCardView";
import ViewSocial from "@/view/pages/otherQrTypes/socialMedia/component/viewSocial";
import MockUpMain from "../../../businessPage/components/mockUp";
import { AtomSpinner } from "epic-spinners"; 

export default {
  name: "socialMobile4_ok",
  components: {
    MockUpMain,
    DragList,
    ViewSocial,
    BIntroSliderView,
    FloatingBtn,
    AtomSpinner
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
     orders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showSplash: true,
      loadingVcf: false,
      showconncet: false,
    };
  },
  computed: {
    draggingKeys: {
      get() {
        return this.orders && this.orders.length > 0 
          ? this.orders 
          : [
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' }
            ];
      },
      set(val) {
        this.$emit('update:orders', val);        
      }
    },
    backgroundImage() {
      if (this.value && this.value.photo && this.value.photo.headBackground) {
        return this.value.photo.headBackground;
      }
      return null;      
    },
    computedBanner: {
      get() {
        if (this.value && this.value.banner && this.value.banner.gallery && this.value.banner.gallery[0] && this.value.banner.gallery[0].images && this.value.banner.gallery[0].images.length > 0) {
          return {
            banner: this.value.banner.gallery[0]
          };
        }
        return null;
      }
    }  
  },
  mounted() {
    Bus.$on("showMe", () => {
      this.showSplash = true;
      setTimeout(() => {
        this.showSplash = false;
      }, 3000); 
    });
    
    setTimeout(() => {
      this.showSplash = false;
    }, 3000);
  },
  methods: {
      openLink(){
    window.open('https://qrland.ir', '_blank');
  },

    show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },
    getVcf() {
      this.loadingVcf = true;
      try {
        const data = (this.value && this.value.data) ? this.value.data : this.value;
        const name = (data && data.organizationName) ? data.organizationName : ((data && data.visitName) ? data.visitName : "مخاطب جدید");
        
        const escapeStr = (str) => {
          if (!str) return '';
          return String(str).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
        };

        const foldLine = (line) => {
          const result = [];
          let current = line;
          while (current.length > 75) {
            result.push(current.substring(0, 75));
            current = " " + current.substring(75);
          }
          result.push(current);
          return result.join("\r\n");
        };

        let vcard = [];
        vcard.push("BEGIN:VCARD");
        vcard.push("VERSION:3.0");
        vcard.push(`PRODID:-//Terminal Ads//FA//EN`);
        vcard.push(`FN:${escapeStr(name)}`);
        vcard.push(`N:${escapeStr(name)};;;;`);

        if (data && data.organizationName) vcard.push(`ORG:${escapeStr(data.organizationName)}`);
        if (data && data.website) vcard.push(`URL:${escapeStr(data.website)}`);
        if (data && data.aboutUs) vcard.push(`NOTE:${escapeStr(data.aboutUs)}`);

        const socialPlatforms = ['instagram', 'telegram', 'whatsapp', 'linkedin', 'twitter', 'x', 'facebook', 'youtube', 'github', 'tiktok', 'pinterest', 'twitch', 'aparat', 'eitaa', 'bale', 'rubika', 'soroush', 'gap', 'igap', 'virgool'];
        
        if (data && data.socialMedia) {
          Object.keys(data.socialMedia).forEach(key => {
            const val = data.socialMedia[key];
            if (!val) return;
            
            const cleanVal = escapeStr(val);
            if (key.toLowerCase() === 'whatsapp') {
              vcard.push(`TEL;TYPE=WORK,VOICE:${cleanVal}`);
              vcard.push(`URL;TYPE=WhatsApp:https://wa.me/${cleanVal.replace(/[^0-9]/g, '')}`);
            } else if (['phone', 'mobile', 'call'].includes(key.toLowerCase())) {
              vcard.push(`TEL;TYPE=CELL,VOICE:${cleanVal}`);
            } else if (key.toLowerCase() === 'email') {
              vcard.push(`EMAIL;TYPE=INTERNET:${cleanVal}`);
            } else if (key.toLowerCase() === 'address') {
              vcard.push(`ADR;TYPE=WORK:;;${cleanVal};;;;`);
            } else if (socialPlatforms.includes(key.toLowerCase())) {
              vcard.push(`X-SOCIALPROFILE;TYPE=${key.toLowerCase()}:${cleanVal}`);
            }
          });
        }

        vcard.push("END:VCARD");
        const vcardString = vcard.map(foldLine).join('\r\n');
        const blob = new Blob([vcardString], { type: 'text/vcard;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name.replace(/\s+/g, "_")}.vcf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (error) {
        console.error("Error generating VCF:", error);
      } finally {
        this.loadingVcf = false;
      }
    }
  }
};
</script>

<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none; 
  scrollbar-width: none; 
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.glass-float-btn {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
}

/* .profile-glass-card, .about-glass-card, .social-glass-container {
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.08) !important;
}

.social-glass-container {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden; 
} */

.profile-glass-card {
  padding-top: 45px !important; 
}

.avatar-wrapper {
  width: 90px;
  height: 90px;
  border-radius: 20px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -55px; 
  border: 4px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%); 
  z-index: 5;
}

* {
  font-family: 'Vazirmatn', 'Vazir', Tahoma, sans-serif;
}
.drag-item-wrapper{
  box-sizing: border-box !important;
  min-width: 80% !important;
}

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.05;
  z-index: 0;
}

/* ---------------------------------- */
/* پس‌زمینه‌های انحنادار - اصلاح شده برای بازگشت گپ دو تکه */
/* ---------------------------------- */
.bg-shape-top {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 52%;
  border-bottom-left-radius: 70% 30%;
  z-index: 0;
  border-bottom: 5px solid #FFC107 !important;

}

.bg-shape-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 38%; 
  border-top-right-radius: 70% 30%;
  z-index: 0;
  border-top: 5px solid #FFC107 !important;

}

/* ---------------------------------- */
/* کلاس‌های دایره بنر */
/* ---------------------------------- */
.main-circle {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background-color: #fff;
  border: 8px solid #fff;
  z-index: 15; 
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2) !important;
  margin-top: 15px;
  margin-bottom: 25px;
  margin-right: -55px; 
  margin-left: auto;
}

.banner-slider-wrapper {
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden !important; 
  border-radius: 50% !important; 
}

::v-deep .banner-slider-wrapper .v-carousel,
::v-deep .banner-slider-wrapper .v-window,
::v-deep .banner-slider-wrapper .v-window__container {
  height: 100% !important;
}

::v-deep .banner-slider-wrapper .v-carousel__item,
::v-deep .banner-slider-wrapper .v-responsive,
::v-deep .banner-slider-wrapper .v-image,
::v-deep .banner-slider-wrapper img {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover !important;
  border-radius: 0 !important; 
}

::v-deep .banner-slider-wrapper .v-image__image {
  background-size: cover !important;
  background-position: center !important;
  border-radius: 0 !important;
}

::v-deep .banner-slider-wrapper .v-window__prev,
::v-deep .banner-slider-wrapper .v-window__next {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
::v-deep .banner-slider-wrapper .swiper {
  height: 100% !important;
}

.profile-glass-card, .about-glass-card, .social-glass-container {
  background: rgba(255, 255, 255, 0.45) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.1) !important;
  border-radius: 16px;
}
.banner-glass-container {
  background: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}
::v-deep .social-glass-container a, 
::v-deep .social-glass-container span,
::v-deep .social-glass-container p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  direction: ltr;
  display: inline-block;
}
/* --- Golden Borders --- */
  .background-svg-class path, 
    svg path {
      stroke: #FFC107 !important;
      stroke-width: 4px !important;
    }
/* --- Golden Borders (Warm Gold) --- */
.logo-circle,
.glass-float-btn,
.profile-glass-card,
.about-glass-card,
.social-glass-container,
.about-glass-card a,
.vcf-btn {
  border: 2px solid #FFC107 !important; 
}

.avatar-wrapper {
  border: 4px solid #FFC107 !important;
}

.main-circle {
  border: 6px solid #FFC107 !important; 
}
</style>
